import {
  addDisplayName,
  addHandlers,
  addProps,
  addState,
  flowMax,
} from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { typedAs } from 'shared/src/utils/typedAs'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Button } from './Button'

interface Props {
  suggestion: string | number
}

const useStyles = createUseStyles({
  container: {
    border: '#E0F7FA 1px solid',
    backgroundColor: '#E1F5FE',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.25em 0.5em',
    marginBottom: '0.25em',
    fontSize: 'smaller',
  },
})

type CopyState = 'notCopied' | 'copied'

export const Suggestion: FC<Props> = flowMax(
  addDisplayName('Suggestion'),
  addState('copyState', 'setCopyState', typedAs<CopyState>('notCopied')),
  addTranslationHelpers,
  addProps(({ copyState, t }) => ({
    classes: useStyles(),
    buttonText:
      copyState === 'notCopied'
        ? t('admin.resources.general.suggestion.copy')
        : t('admin.resources.general.suggestion.copied'),
  })),
  addHandlers({
    copySuggestion:
      ({ suggestion, setCopyState }) =>
      () => {
        navigator.clipboard.writeText(`${suggestion}`)
        setCopyState('copied')
        setTimeout(() => {
          setCopyState('notCopied')
        }, 1000)
      },
  }),
  ({ classes, suggestion, buttonText, copySuggestion }) => (
    <div className={classes.container}>
      {suggestion}{' '}
      <Button type="textWrapped" text={buttonText} onClick={copySuggestion} />
    </div>
  )
)
